import React from "react";
import { Link } from "react-router";

// import { ACTION_RULES, has_action } from "../../../../helpers/authorization";

export default class TableActions extends React.Component {
	constructor(props) {
		super(props);
        this.menuItems = [];
		// const { item, router, actions_permissions } = this.props;
		// if (has_action(ACTION_RULES.can_detail, actions_permissions)) {
		// 	this.menuItems.push(
		// 		<button onClick={() => this.showModalDetail(item)}>
		// 			<i className="fa fa-eye" />
		// 			<span>Visualizar</span>
		// 		</button>
		// 	);
		// }
		// if (has_action(ACTION_RULES.can_create, actions_permissions)) {
		// 	this.menuItems.push(
		// 		<button
		// 			onClick={() => {
		// 				delete item[this.props.customID];
		// 				this.props.router.push({
		// 					pathname: `${router.location.pathname}/novo`,
		// 					state: item
		// 				});
		// 			}}
		// 		>
		// 			<i className="fa fa-clone" />
		// 			<span>Duplicar</span>
		// 		</button>
		// 	);
		// }
		// if (has_action(ACTION_RULES.can_edit, actions_permissions)) {
		// 	this.menuItems.push({
		// 		leftIcon: <i className="fa fa-pencil-square-o" />,
		// 		primaryText: "Editar",
		// 		onClick: () => {
		// 			this.props.router.push(
		// 				`${router.location.pathname}/${item[this.props.customID]}/editar`
		// 			);
		// 		}
		// 	});
		// }
		// if (has_action(ACTION_RULES.can_remove, actions_permissions)) {
		// 	this.menuItems.push({
		// 		leftIcon: <i className="fa fa-trash-o" />,
		// 		primaryText: "Excluir",
		// 		onClick: () => this.showModalDelete(item)
		// 	});
		// }
	}

	showModalDelete(item) {
		this.props.deleteitem(item);
	}

	showModalDetail(item) {
		this.props.detailitem(item);
	}

	duplicateItem = (item) => {
		delete item[this.props.customID];
		this.props.router.push({
			pathname: `${this.props.router.location.pathname}/novo`,
			state: item
		});
	}

	render() {
        const { router, item } = this.props;
		// if (this.menuItems.length > 0) {
		if (true) {
			return (
				<div style={{display: 'flex'}}>
					{/* <div style={{cursor: 'pointer', padding: '0 1rem'}} onClick={() => this.showModalDetail(item)}>
						<i className="fa fa-eye" style={{ fontSize: '1.6rem'}} />
						<span style={{display: 'none'}}>Visualizar</span>
					</div> */}
					<div style={{cursor: 'pointer', padding: '0 1rem'}} onClick={() => this.duplicateItem(item)}>
						<i className="fa fa-clone" style={{ fontSize: '1.6rem'}} />
						<span style={{display: 'none'}}>Duplicar</span>
					</div>
                    <Link style={{cursor: 'pointer', padding: '0 1rem'}} to={`${router.location.pathname}/${item[this.props.customID]}/editar`}>
						<i className="fa fa-pencil-square-o" style={{ fontSize: '1.6rem'}} />
						<span style={{display: 'none'}}>Editar</span>
					</Link>
                    <div style={{cursor: 'pointer', padding: '0 1rem'}} onClick={() => this.showModalDelete(item)}>
						<i className="fa fa-trash-o" style={{ fontSize: '1.6rem', color: 'red'}} />
						<span style={{display: 'none'}}>Excluir</span>
					</div>
				</div>
			);
		}
		return null;
	}
}
